/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from '../../../saas/AppConfigWrapper';

function AppRadioInput({
  id,
  name,
  labelText,
  onChange,
  labelClassName,
  radioClassName,
  checked,
  ...rest
}) {
  const { appConfig } = useAppContext();

  const handleLabelClick = (e) => {
    if (e.target.tagName === 'INPUT') return;
    onChange({
      target: { name, value: rest.value, type: 'radio', checked: true },
    });
  };

  return (
    <label
      className={` d-flex ${labelClassName} fw-500 align-items-center fs-12 cursor-pointer ${
        checked ? 'radio-label-checked' : ''
      }`}
      htmlFor={id}
      style={{ color: checked ? '#1e1e1e' : '#768391' }}
      onClick={handleLabelClick}
    >
      <input
        className={`cursor-pointer ${radioClassName}`}
        id={id}
        type="radio"
        name={name}
        checked={checked}
        onChange={onChange}
        {...rest}
        style={{
          appearance: 'none',
          borderWidth: '2px',
          borderStyle: 'solid',
          width: '16px',
          height: '16px',
          borderRadius: '50%',
          borderColor: checked ? appConfig?.clientPrimaryColor : '#768391',
          backgroundColor: checked ? appConfig?.clientPrimaryColor : '#fff',
          marginRight: '7px',
          boxShadow: checked ? 'inset 0 0 0 2px #fff' : 'none',
        }}
      />
      {labelText}
    </label>
  );
}

AppRadioInput.defaultProps = {
  labelClassName: '',
  radioClassName: '',
  labelText: '',
  checked: false,
};

AppRadioInput.propTypes = {
  checked: PropTypes.any,
  labelText: PropTypes.any,
  labelClassName: PropTypes.string,
  radioClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AppRadioInput;
